import React, { useEffect, useState } from "react";
import ReactCardFlip from "react-card-flip";
import jsPDF from "jspdf";
import { Link, useNavigate } from "react-router-dom";

import html2canvas from "html2canvas";

function Broucher() {
    const baseUrl =
        process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_BASE_URL_DEV
            : process.env.REACT_APP_BASE_URL_PROD;

    const baseUrl1 =
        process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_BASE_URL_DEV1
            : process.env.REACT_APP_BASE_URL_PROD1;


    // console.log(baseUrl1, "boucher")
    const [isFlippedArray, setIsFlippedArray] = useState([]);
    const [bouchers, setBouchers] = useState([]);
    // console.log(bouchers, baseUrl1)


    const handleClick = (index) => {
        setIsFlippedArray((prev) => {
            const newArray = [...prev];
            newArray[index] = !newArray[index];
            return newArray;
        });
    };
    const handleDownload = async (id, item) => {
        try {
            const frontImageUrl = `${baseUrl1}${item.frontImage}`;
            const backImageUrl = `${baseUrl1}${item.backImage}`;

            // console.log(frontImageUrl, backImageUrl, "kkjk");

            const frontImg = new Image();
            const backImg = new Image();

            const frontImagePromise = new Promise((resolve, reject) => {
                frontImg.onload = resolve;
                frontImg.onerror = () => reject(new Error("Front image failed to load"));
                frontImg.src = frontImageUrl;
            });

            const backImagePromise = new Promise((resolve, reject) => {
                backImg.onload = resolve;
                backImg.onerror = () => reject(new Error("Back image failed to load"));
                backImg.src = backImageUrl;
            });

            await Promise.all([frontImagePromise, backImagePromise]);

            const pdf = new jsPDF("portrait", "mm", "a4");

            pdf.addImage(frontImg, "PNG", 10, 10, 190, 270);

            pdf.addPage();

            pdf.addImage(backImg, "PNG", 10, 10, 190, 270);

            pdf.save(`brochure-${id}.pdf`);
        } catch (error) {
            console.error("Error generating PDF:", error);
        }
    };




    useEffect(() => {
        const fetchBouchers = async () => {
            try {
                const response = await fetch(`${baseUrl}/booking/getbouchers`);
                const result = await response.json();

                if (response) {
                    setBouchers(result.bouchers);
                    // console.log(result, "hhhh")
                } else {
                    console.error(result.message);
                }
            } catch (error) {
                console.error("Error fetching brochures:", error);
            }
        };

        fetchBouchers();
    }, []);
    return (
        <div className="relative min-h-auto mb-10">
            <div className="pt-20 lg:pt-[140px]">
                <div className="flex justify-between xl:px-[120px] px-3 my-4">
                    <Link to="/">

                        <button className="flex gap-2 items-center cursor-pointer w-[100px]">
                            <svg
                                width="24"
                                height="25"
                                viewBox="0 0 24 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M19 11.4997H7.82999L12.71 6.61967C13.1 6.22967 13.1 5.58967 12.71 5.19967C12.6175 5.10697 12.5076 5.03342 12.3866 4.98324C12.2656 4.93306 12.136 4.90723 12.005 4.90723C11.874 4.90723 11.7443 4.93306 11.6234 4.98324C11.5024 5.03342 11.3925 5.10697 11.3 5.19967L4.70999 11.7897C4.61728 11.8822 4.54373 11.9921 4.49355 12.113C4.44337 12.234 4.41754 12.3637 4.41754 12.4947C4.41754 12.6256 4.44337 12.7553 4.49355 12.8763C4.54373 12.9973 4.61728 13.1072 4.70999 13.1997L11.3 19.7897C11.3926 19.8823 11.5025 19.9557 11.6234 20.0058C11.7444 20.0559 11.8741 20.0817 12.005 20.0817C12.1359 20.0817 12.2656 20.0559 12.3865 20.0058C12.5075 19.9557 12.6174 19.8823 12.71 19.7897C12.8026 19.6971 12.876 19.5872 12.9261 19.4662C12.9762 19.3453 13.002 19.2156 13.002 19.0847C13.002 18.9537 12.9762 18.8241 12.9261 18.7031C12.876 18.5822 12.8026 18.4723 12.71 18.3797L7.82999 13.4997H19C19.55 13.4997 20 13.0497 20 12.4997C20 11.9497 19.55 11.4997 19 11.4997Z"
                                    fill="#11485B"
                                />
                            </svg>
                            <p className="text-[#11485B] font-[600]">Back</p>
                        </button>
                    </Link>
                    <p className="text-[#11485B] text-[14px] mt-4 md:text-[22px] font-semibold whitespace-nowrap">
                        Our Brochure
                    </p>
                </div>
                <div className="mt-8  md:flex justify-center flex-wrap gap-4 px-5">
                    {bouchers.length === 0 ? (
                        <div className="container">
                            <div className='container '>
                                <img src="../logo1.png" alt="" className="box-one h-[200px] w-[200px]" />
                            </div>
                        </div>





                    ) : (
                        bouchers.map((item, index) => (
                            <div key={item._id} className="relative">
                                <ReactCardFlip
                                    isFlipped={!!isFlippedArray[index]}
                                    flipDirection="horizontal"
                                >

                                    {/* Front Side */}
                                    <div
                                        id={`front-${item._id}`}
                                        className="w-full h-[440px] mt-4 border group relative z-10 overflow-hidden bg-gray-100"
                                        onClick={() => handleClick(index)}
                                    >


                                        <img
                                            src={`${baseUrl1}${item.frontImage}`}
                                            alt="Front Side"
                                            className="w-full h-full object-cover"
                                        />
                                        <p>({`${baseUrl1}item.frontImage`})</p>

                                        <button
                                            className="absolute top-4 right-4 bg-white text-white p-2 rounded-full z-50"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDownload(item._id, item);
                                            }}
                                        >
                                            <img src="../assets/download.png" alt="" className="h-4" />
                                        </button>
                                        <div className="absolute top-0 left-0 h-full w-full flex items-end bg-gradient-to-b from-[#000] to-[#000] opacity-0 group-hover:opacity-50 transition-opacity duration-300 ease-in-out z-10">
                                            <div className="flex justify-center items-end h-full w-full">
                                                <p className="text-[#ffffff] pb-1 md:text-[20px] text-[16px] font-[600]">
                                                    Click here to Flip
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Back Side */}
                                    <div
                                        id={`back-${item._id}`}
                                        className="w-full h-[440px] border group bg-white relative z-10 overflow-hidden"
                                        onClick={() => handleClick(index)}
                                    >
                                        <img
                                            src={`${baseUrl1}${item.backImage}`}
                                            alt="Back Side"
                                            className="w-full h-full object-cover "
                                        />
                                        <button
                                            className="absolute top-4 right-4 bg-white text-white p-2 rounded-full z-50"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDownload(item._id, item);
                                            }}
                                        >
                                            <img src="/assets/download.png" alt="" className="h-4" />
                                        </button>
                                        <div className="absolute top-0 left-0 h-full w-full flex items-end bg-gradient-to-b from-[#000] to-[#000] opacity-0 group-hover:opacity-50 transition-opacity duration-300 ease-in-out z-10">
                                            <div className="flex justify-center items-end h-full w-full">
                                                <p className="text-[#ffffff] pb-1 md:text-[20px] text-[16px] font-[600]">
                                                    Click here to Flip
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </ReactCardFlip>
                            </div>
                        ))
                    )}

                </div>
            </div>
        </div>
    );
}

export default Broucher;
